var amblems = {
    // England
    LEI: 'Fake_Leicester.png',
    BOU: 'Fake_Bournmouth.png',
    HDD: 'Fake_Huddersfield.png',
    WHU: 'Fake_WestHamUtd.png',
    SWA: 'Fake_SwanCity.png',
    WAT: 'Fake_Watford.png',
    BRH: 'Fake_BrightHoveAlbion.png',
    BUR: 'Fake_Burnley.png',
    WBA: 'Fake_Broomwich.png',
    CHE: 'Fake_Chelsea.png',
    NEW: 'Fake_NewCastle.png',
    MUN: 'Fake_Manchester.png',
    SOU: 'Fake_Southampton.png',
    TOT: 'Fake_TottenhamHotspur.png',
    ARS: 'Fake_Arsenal.png',
    EVE: 'Fake_Everton.png',
    CRY: 'Fake_CrystalPalace.png',
    LIV: 'Fake_Liverpool.png',
    MCI: 'Fake_ManchesterCity.png',
    STK: 'Fake_StrokeCity.png',
    // Italy
    VER: 'Fake_StrokeCity.png',
    INT: 'Inter.png',
    ATA: 'Fake_StrokeCity.png',
    BOL: 'Fake_StrokeCity.png',
    BRE: 'Fake_StrokeCity.png',
    CAG: 'Fake_StrokeCity.png',
    FIO: 'Fake_StrokeCity.png',
    GEN: 'Fake_StrokeCity.png',
    JUV: 'Juventus.png',
    LAZ: 'Lazio.png',
    USL: 'Fake_StrokeCity.png',
    MIL: 'Milan.png',
    NAP: 'Fake_StrokeCity.png',
    PAR: 'Fake_StrokeCity.png',
    ROM: 'Roma.png',
    SAM: 'Fake_StrokeCity.png',
    SAS: 'Fake_StrokeCity.png',
    SPA: 'Fake_StrokeCity.png',
    TOR: 'Fake_StrokeCity.png',
    UDI: 'Fake_StrokeCity.png',
    // Spanish
    ALA: "Alaves.png",
    ATM: "Atm.png",
    BAR: "Barcelona.png",
    BIL: "Bilbao.png",
    CEV: "Cev.png",
    EIB: "Eibar.png",
    ESP: "Esp.png",
    GET: "Get.png",
    GRA: "Gra.png",
    LEG: "Leg.png",
    LEV: "Lev.png",
    OSA: "Osa.png",
    REB: "Reb.png",
    REM: "Rem.png",
    MAL: "Mal.png",
    REV: "Rev.png",
    SEV: "Sev.png",
    VAL: "Val.png",
    VIL: "Vil.png",

};

 module.exports = {
     getLatestResults : function(data){

        $.each( data['LeagueMatches'], function( key, value ) {

        var homeGoals = 0;
        var awayGoals = 0;
        latestResults[key] = {};

        if (!value.video1 || !value.video2 || !value.video3 || !value.video4 || !value.video5 || !value.video6) {
            homeGoals = '-';
            awayGoals = '-';
            var gameFlow = [
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - ',
                ' - : - '
            ];
        } else {
            video1Result = value.video1.split('_')[1];
            video2Result = value.video2.split('_')[1];
            video3Result = value.video3.split('_')[1];
            video4Result = value.video4.split('_')[1];
            video5Result = value.video5.split('_')[1];
            video6Result = value.video6.split('_')[1];
    
            homeGoals = parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0));
            awayGoals = parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1));
    
            var gameFlow = [
                parseInt(video1Result.charAt(0)) +':'+parseInt(video1Result.charAt(1)),
                (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0))) +' - '+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) +  parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)))  +' - '+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0))) +' - '+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0))) +' - '+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1))),
                (parseInt(video1Result.charAt(0)) + parseInt(video2Result.charAt(0)) + parseInt(video3Result.charAt(0)) + parseInt(video4Result.charAt(0)) + parseInt(video5Result.charAt(0)) + parseInt(video6Result.charAt(0))) +' - '+ (parseInt(video1Result.charAt(1)) + parseInt(video2Result.charAt(1)) + parseInt(video3Result.charAt(1)) + parseInt(video4Result.charAt(1)) + parseInt(video5Result.charAt(1)) + parseInt(video6Result.charAt(1))),
            ];
        }

         window['latestResults'][key] = {
            gameId : value.ID,
            TeamNameHome : value.TeamNameHome,
            TeamNameAway : value.TeamNameAway,
            Kit_Away : value.Kit_Away,
            Kit_Home : value.Kit_Home,
            LogoAway : value.LogoAway,
            LogoHome : value.LogoHome,
            homeGoals : homeGoals,
            awayGoals : awayGoals,
            CodeHome : value.CodeHome,
            CodeAway : value.CodeAway,
            gameFlow : gameFlow,
            halftime : gameFlow[2]
        };
    });
    },
    drawLatestResults : function(){
        var updateCreditEvent = new CustomEvent("get_credit");
        window.dispatchEvent(updateCreditEvent);
        $('#latest-results').html('');
        $('#latest-results').append('<div class="game-holder-bar" style="display:block" data-langName="last_results">' + langArr[lang].last_results + '</div>');
        i = 0;
        $.each( window['latestResults'], function( key, value ) {

            if(i % 2 == 0){
                $('#latest-results').append('<div class="vfl-lr-holder clearfix" >');
            }

            $('#latest-results').append(resultsHtml(value));

            if(i % 2 == 0){
                $('#latest-results').append('</div>');
            }
            i++;
        });
        $('#latest-results').append('<div class="vfl-lr-holder clearfix" ></div> ');
        localStorage.setItem('last_result', JSON.stringify(window['latestResults']));
    }
};

function resultsHtml(data) {
    var html = '<div class="vfl-lr clearfix">'+
            '<div class="vfl-lr-game clearfix">'+
                '<div class="vfl-lr-home-amblem" style="background-image:url(img/amblems/left/logos/'+amblems[data.CodeHome]+');"></div>'+
                '<div class="vfl-lr-home-away">'+
                    data.TeamNameHome+' - '+data.TeamNameAway+
                    '<div class="vfl-lr-id">'+data.gameId+'</div>'+
                '</div>'+
                '<div class="vfl-lr-away-amblem" style="background-image:url(img/amblems/right/logos/'+amblems[data.CodeAway]+')"></div>'+
            '</div>'+
            '<div class="vfl-lr-score clearfix">'+
                '<div class="vfl-lr-score-ht">('+data.halftime.toString().trim()+')</div>'+
                '<div class="vfl-lr-score-ft">'+data.homeGoals.toString().trim()+' - '+data.awayGoals.toString().trim()+'</div>'+
            '</div>'+
        '</div>';

        return html;
}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/results/results.js
// module id = 2023
// module chunks = 4